import styled from 'styled-components';

import {
   basicCaptionSmallTextStyle,
   basicSmallTextStyle,
   fonts,
   IconWrapper,
   RowDetails,
   StyledFlex,
} from '@dreryk/react-components';

export const StyledP1PrescriptionRowDetails = styled(RowDetails)`
   ${basicSmallTextStyle};
   padding-left: 4px;
`;
StyledP1PrescriptionRowDetails.displayName = 'StyledP1PrescriptionRowDetails';

export const StyledP1PrescriptionIssuedFromCell = styled(StyledFlex)`
   gap: 4px;
   align-items: center;
`;
StyledP1PrescriptionIssuedFromCell.displayName = 'StyledP1PrescriptionIssuedFromCell';

export const StyledP1PrescriptionStatusIcon = styled(IconWrapper)<{ color: string }>`
   fill: ${(props) => props.color};

   &:hover {
      fill: ${(props) => props.color};
   }
`;
StyledP1PrescriptionStatusIcon.displayName = 'StyledP1PrescriptionStatusIcon';

export const StyledP1PrescriptionStatusTooltipContent = styled(StyledFlex)`
   ${basicSmallTextStyle};
   flex-direction: column;
   gap: 4px;
`;
StyledP1PrescriptionStatusTooltipContent.displayName = 'StyledP1PrescriptionStatusTooltipContent';

export const StyledP1PrescriptionStatusTooltipTitle = styled.div<{ color: string }>`
   ${basicCaptionSmallTextStyle};
   display: flex;
   align-items: center;
   gap: 4px;
   text-transform: uppercase;
   font-weight: ${fonts.fontWeightBold};
   color: ${(props) => props.color};
`;
StyledP1PrescriptionStatusTooltipTitle.displayName = 'StyledP1PrescriptionStatusTooltipTitle';

export const StyledP1PrescriptionStatusTooltipTitleIcon = styled.span`
   display: block;
   width: 12px;
   height: 12px;
   fill: currentColor;
`;
StyledP1PrescriptionStatusTooltipTitleIcon.displayName = 'StyledP1PrescriptionStatusTooltipTitleIcon';
